import { DropDownListComponent } from "../../General/DropDownListComponent";

const AgentLicenseFilterForm = ({
  stateList,
  statusList,
  filterHandler,
  resetForm,
}) => {
  return (
    <div>
      <form className="my-4 grid grid-cols-1 gap-x-12 gap-y-6 md:grid-cols-3">
        <div className="flex items-center">
          <label className="pr-4" htmlFor="agentLicenseStateFilter">
            State:
          </label>
          <DropDownListComponent
            id="agentLicenseStateFilter"
            name="state"
            valueList={stateList}
            onChangeHandler={filterHandler}
          />
        </div>
        <div className="flex items-center">
          <label className="pr-4" htmlFor="agentLicenseStatusFilter">
            Status:
          </label>
          <DropDownListComponent
            id="agentLicenseStatusFilter"
            name="status"
            valueList={statusList}
            onChangeHandler={filterHandler}
          />
        </div>
        <button
          className="ui-btn-primary my-auto place-self-end"
          onClick={resetForm}
          type="reset"
        >
          Reset
        </button>
        {/* <div className="flex items-end">
        </div> */}
      </form>
    </div>
  );
};

export { AgentLicenseFilterForm };
